// All colors used in the game, in one place.
// Numbers are Phaser-friendly 0xRRGGBB.

export const COLORS = {
  // Frame + workspace
  bgOuter: 0x1a1422,
  frameOuter: 0x4a3f6b,
  frameMid: 0x6b5d8e,
  frameInner: 0x3a3148,
  workspaceFill: 0x3a3a3a,
  workspaceEdge: 0x2a2a2a,

  // UI bar
  uiBarFill: 0x2a2238,
  uiBarStroke: 0x4a3f6b,
  buttonIdleFill: 0xeaeaea,
  buttonIdleText: 0x222222,
  buttonStartFill: 0x6dc24a,
  buttonStartText: 0x1c3c11,
  buttonStopFill: 0xc63232,
  buttonStopText: 0xffffff,

  // Pipes (idle/gray)
  idleFill: 0x9a9a9a,
  idleOutline: 0x383838,
  idleHighlight: 0xc8c8c8,
  // Pipes (flowing/red — blood)
  flowFill: 0xc63232,
  flowOutline: 0x4a1010,
  flowHighlight: 0xff7878,

  // Pipes (flowing/yellow-green — gruel)
  flowFillGruel: 0xb6c83a,
  flowOutlineGruel: 0x4a5018,
  flowHighlightGruel: 0xe8f08e,

  // Molecules
  molFood: 0x4ec858,
  molFoodOutline: 0x1a4a20,
  molOxygen: 0x4a9fff,
  molOxygenOutline: 0x1a3060,
  molCo2: 0xf6c83c,
  molCo2Outline: 0x806010,
  molGruel: 0xc4d44a,
  molGruelOutline: 0x4a5018,
  // Waste — brown blob (intestines bottom-out). Visually distinct from gruel
  // (yellow-green) so students can tell waste from undigested gruel.
  molWaste: 0x7a4a1c,
  molWasteOutline: 0x2e1808,

  // Blood spurt particle
  bloodSpurt: 0xc63232,

  // Ports
  portRim: 0x4a4a4a,
  portFace: 0x9a9a9a,
  portLens: 0x222222,
  portConeFill: 0xbababa,
  portConeOutline: 0x4a4a4a,

  // Burst X
  burstX: 0xff2020,

  // Legend text
  legendText: 0x222222,
  legendBg: 0xf4f0e8,
};
